export default __webpack_public_path__ + "static/media/united-kingdom.50a5fbc7.svg";